import type { CustomCellRendererProps } from '@cmg/data-grid';
import { Link, Stack, Tooltip, Typography } from '@cmg/design-system';
import isEmpty from 'lodash/isEmpty';

import routeFactory from '../../../../../common/util/routeFactory';
import type { InvestorFirmFragment } from '../graphql/__generated__';

type InvestorContactsCellRendererProps = Readonly<
  CustomCellRendererProps<InvestorFirmFragment, InvestorFirmFragment['investorContactsCount']>
>;

const MAX_DISPLAYED_CONTACTS = 5;

export function InvestorContactsCellRenderer({ value, data }: InvestorContactsCellRendererProps) {
  const contacts = data?.investorContacts?.items ?? [];
  const showSeeMore = (data?.investorContactsCount ?? 0) > MAX_DISPLAYED_CONTACTS;

  const seeMoreLink =
    data?.id &&
    routeFactory.customerCrmInvestorFirmInvestorContactsGrid.getUrlPath({
      firmId: data?.id,
    });

  return (
    <Tooltip
      variant="info"
      placement="top"
      title={
        !isEmpty(contacts) && (
          <Stack gap={1}>
            {contacts
              .slice(0, MAX_DISPLAYED_CONTACTS)
              .map(({ investorEmployeeId, name, email1 }) => (
                <Stack key={investorEmployeeId}>
                  <Typography variant="tooltip">{name}</Typography>
                  <Typography variant="caption">{email1}</Typography>
                </Stack>
              ))}
            {showSeeMore && seeMoreLink && (
              <Link href={seeMoreLink} variant="tooltip">
                See more
              </Link>
            )}
          </Stack>
        )
      }
    >
      <span data-testid="investor-contacts-cell">{value}</span>
    </Tooltip>
  );
}
